// Main Scripts
// ---------------------
import headerButtons from './js/widgets/headerButtons.js';

import mainSlideshowConcept2 from './js/widgets/mainSlideshowConcept2.js';
import seoWidget from './js/widgets/seoWidget.js';
import multiScheduleFeatureConcept1 from './js/widgets/multiScheduleFeatureConcept1.js';
import snowCards from './js/widgets/snowCards.js';
import videoCards from './js/widgets/videoCards.js';
import videoWidget from './js/widgets/videoWidget.js';
import hotButtons from './js/widgets/hotButtons.js';
import multipleCustomSponsors from './js/widgets/multipleCustomSponsors.js';
import socialPictures from './js/widgets/socialPictures.js';
import microModal from './js/widgets/microModal';

// Secondary Scripts
// ---------------------
import './js/localjs.js';
import MicroModal from 'micromodal';

import AOS from 'aos';
import 'aos/dist/aos.css';

$(document).ready(function () {
  setTimeout(() => {
    AOS.init({
      anchorPlacement: 'bottom-bottom',
      animatedClassName: 'aos-animate',
      initClassName: 'aos-init',
    });
  }, 2000);

  headerButtons();

  if (window.location.pathname === '/') {
    mainSlideshowConcept2();
    seoWidget();
    multiScheduleFeatureConcept1();
    snowCards();

    $(window).load(function () {
      videoWidget();
      microModal();
      MicroModal.init();
    });

    videoCards();
    hotButtons();

    multipleCustomSponsors('scrollerSponsors', scrollerSponsorsOpts);
    multipleCustomSponsors('staticSponsors', staticSponsorsOpts);
    socialPictures();
  }
});
